import axios from "axios";

export default function LoginNow(username: string, password: string): Promise<{access_token: string}>{
    return new Promise((resolve, reject) => {
        axios.post('/auth/login', {username: username, password: password}).then(res => {
            resolve(res.data)
        }).catch(err => reject(err))
    })

}
